<footer class="text-gray-600 body-font bg-white">
  <div class="container px-5 py-4 mx-auto flex items-center sm:flex-row flex-col">
    <p class="text-sm text-gray-500 sm:ml-4 sm:pl-4 sm:py-2 sm:mt-0 mt-4">Créer avec <img
      class="w-8 h-8 inline-block"
      src="./images/coeur.png"
      alt="coeur icon"
      width="16"
      height="16"
    /> par Hugo Suissia —
      Icônes conçues par <a
      href="https://www.flaticon.com/fr/auteurs/good-ware"
      title="Good Ware"
      class="text-blue-500 underline">Good Ware</a
    >,
    <a
      href="https://www.freepik.com"
      title="Freepik"
      class="text-blue-500 underline">Freepik</a
    >,
    <a
      href="https://www.flaticon.com/authors/iconsbox"
      title="IconsBox"
      class="text-blue-500 underline">IconsBox</a
    >. Retrouvez les sur
    <a
      href="https://www.flaticon.com/fr/"
      title="Flaticon"
      class="text-blue-500 underline">www.flaticon.com</a
    >
    </p>
  </div>
</footer>